import ExportMatrix from './ExportMatrix';
import { buildCodeList } from './exportUtils';

const COL_OFFSET = 3;
const ROW_OFFSET = 2;

const TRANSCRIPT_OFFSET = 1;
const TRANSCRIPT_DESCRIPTION_OFFSET = TRANSCRIPT_OFFSET - 1;

const TRANSCRIPT_DESCRIPTION = '# of snippets in this transcript';

const EXPORT_NAME = 'Code x Transcript Matrix';


// Helper to extract transcript list from project data or report data
function getTranscriptList(projectData, reportData) {
  // Try to get transcripts from project data first
  if (projectData?.transcripts) {
    return projectData.transcripts.map(t => ({
      id: t.id || t.server_id,
      name: t.name || 'Untitled Transcript'
    }));
  }
  
  // Handle nested report structure from API response
  const report = reportData?.data?.report || reportData?.report || reportData;
  
  // Fall back to extracting from report data if available
  if (report?.transcripts) {
    return Object.keys(report.transcripts).map(id => ({
      id: parseInt(id), // Convert string ID to number for consistency
      name: report.transcripts[id].name || 'Untitled Transcript'
    }));
  }
  
  return [];
}

const codesVTranscriptsArray = (projectData, codesData, reportData) => {
  const codes = buildCodeList(codesData);
  const projectName = projectData?.name || 'Project';
  // Handle nested report structure from API response
  const report = reportData?.data?.report || reportData?.report || reportData;
  const transcriptList = getTranscriptList(projectData, reportData);

  const matrix = new ExportMatrix(codes.length + ROW_OFFSET, transcriptList.length + COL_OFFSET);

  const transcriptNames = transcriptList.map((t) => t.name);

  matrix.setCodeRows(codes, ROW_OFFSET, COL_OFFSET);
  matrix.setRow(transcriptNames.map(() => TRANSCRIPT_DESCRIPTION), TRANSCRIPT_DESCRIPTION_OFFSET, COL_OFFSET);
  matrix.setRow(transcriptNames, TRANSCRIPT_OFFSET, COL_OFFSET);

  if (report && report.transcripts) {
    for (let transcriptIndex = 0; transcriptIndex < transcriptList.length; transcriptIndex++) {
      const { id } = transcriptList[transcriptIndex];
      const reportTranscript = report.transcripts[id];
      if (!reportTranscript) continue;
      for (let codeIndex = 0; codeIndex < codes.length; codeIndex++) {
        const [code_id] = codes[codeIndex];
        const reportCode = reportTranscript.codes[code_id];
        if (!reportCode) continue;
        const excerptCount = reportCode.excerpt_count;
        matrix.setValue(codeIndex + ROW_OFFSET, transcriptIndex + COL_OFFSET, excerptCount);
      }
    }
  }

  matrix.setHeaders(projectName, EXPORT_NAME);
  return matrix.toCSV();
};

// New signature: accepts clean data parameters instead of state
const exportCodesVTranscriptsMapper = (projectData, codesData, reportData) => {
  const projectName = projectData?.name || 'Project';
  const exportFileName = `${projectName}_CodeXTranscript`;

  const matrix = codesVTranscriptsArray(projectData, codesData, reportData);

  return {
    projectName: exportFileName,
    matrix
  };
};

export default exportCodesVTranscriptsMapper;